module.exports = __webpack_public_path__ + "img/nopower.dcfaa170.svg";